<div class="w-75 mb-5 pb-3" [storyblokRichText]="content"></div>
@defer (on idle; when true) {
<app-form class="d-block form"></app-form>
} @placeholder {
<div></div>
}
